import JobTitleList from './Request/JobTitle_list';

const mapJobTitleList = jobTitlelist => {
  if (!jobTitlelist) return [];
  return jobTitlelist.map(jobTitle => ({
    id: jobTitle.id,
    name: jobTitle.name,
    department: jobTitle.Department?.name ?? '',
    numberOfEmployees: jobTitle.numberOfEmployees,
    numberOfCourses: jobTitle.numberOfCourses,
    status: jobTitle.status ? 'Activo' : 'Inactivo',
    departmentId: jobTitle.departmentId,
  }));
};

const fetch = async () => {
  const jobTitles = await JobTitleList({ statusFilter: 'ACTIVE' });
  const jobTitleList = mapJobTitleList(jobTitles);
  return { jobTitleList };
};

export default fetch;
